import "./Download.scss";
import { useContext } from "react";
import { LangContext } from "../../context/langContext";
import appStoreBadge from "../../assets/app-store-badge.webp";
import appStoreBadgeEn from "../../assets/app-store-badge-en.webp";
import googlePlayBadge from "../../assets/google-play-badge.webp";
import googlePlayBadgeEn from "../../assets/google-play-badge-en.webp";

const Download = ({ textData }) => {
  const lang = useContext(LangContext);

  return (
    <section className="download" id="download">
      <div className="download__title-container">
        <h2 className="download__title">
          {textData[lang].download.titleWhite}
          <span className="download__title_yellow">
            {textData[lang].download.titleYellow}
          </span>
          <div className="download__stars" />
        </h2>
        <div className="download__gradient" />
      </div>
      <div className="download-links">
        <a
          href="https://apps.apple.com/kz/app/totem-chat/id6444722452"
          className="download-links__item"
        >
          <img
            src={lang === "RU" ? appStoreBadge : appStoreBadgeEn}
            alt="app store"
            className="download-links__icon"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=kz.mobile.totemchat&hl=ru&gl=US"
          className="download-links__item"
        >
          <img
            src={lang === "RU" ? googlePlayBadge : googlePlayBadgeEn}
            alt="google play"
            className="download-links__icon"
          />
        </a>
      </div>
    </section>
  );
};

export default Download;
